/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreelancerFeeTypeResource = {
    CountryFixedFeeRate: 'COUNTRY_FIXED_FEE_RATE',
    DefaultFeeRate: 'DEFAULT_FEE_RATE',
    ForcedFeeRate: 'FORCED_FEE_RATE',
    ReducedFeeRate: 'REDUCED_FEE_RATE',
    ZeroFeeBenefit: 'ZERO_FEE_BENEFIT',
    CustomClientFeeRate: 'CUSTOM_CLIENT_FEE_RATE',
    RepatriationFeeRate: 'REPATRIATION_FEE_RATE',
    MicroConsultingFeeRate: 'MICRO_CONSULTING_FEE_RATE'
} as const;
export type FreelancerFeeTypeResource = typeof FreelancerFeeTypeResource[keyof typeof FreelancerFeeTypeResource];


export function instanceOfFreelancerFeeTypeResource(value: any): boolean {
    for (const key in FreelancerFeeTypeResource) {
        if (Object.prototype.hasOwnProperty.call(FreelancerFeeTypeResource, key)) {
            // @ts-ignore
            if (FreelancerFeeTypeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreelancerFeeTypeResourceFromJSON(json: any): FreelancerFeeTypeResource {
    return FreelancerFeeTypeResourceFromJSONTyped(json, false);
}

export function FreelancerFeeTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerFeeTypeResource {
    return json as FreelancerFeeTypeResource;
}

export function FreelancerFeeTypeResourceToJSON(value?: FreelancerFeeTypeResource | null): any {
    return value as any;
}

